export const faqData = [
  {
    categoryLabel: "Connexion",
    categorySlug: "connexion",
    questions: [
      {
        question: "Comment j'obtiens mon identifiant et mon mot de passe ?",
        answer: `Vous n'êtes pas encore client POwr Connect :
Pour obtenir votre identifiant et votre mot de passe, vous devez créer votre compte [ici](https://powr-connect.shop/inscription) : complétez le formulaire de création de compte et envoyez les documents demandés (RIB + Kbis). Une fois votre demande envoyée, nos services traiteront votre demande et vous communiqueront vos identifiants par mail.

Vous êtes déjà client POwR Connect :
Vous souhaitez avoir accès à notre site powr-connect.shop, rapprochez-vous de votre commercial et demander lui d'ouvrir votre compte client sur le site. Une fois autorisé, vos identifiants de connexion vous seront envoyés par mail.`,
      },
      {
        question: "Comment demander un compte ?",
        answer: `Pour demander l'ouverture d'un compte sur notre webshop powr-connect.shop, vous devez remplir le formulaire de création de compte. Pour remplir le formulaire de création de compte, cliquez [ici](https://powr-connect.shop/inscription).`,
      },
      {
        question: "Comment j'ajoute des collaborateurs à mon compte ?",
        answer: `Il est possible d'inclure plusieurs membres de votre équipe dans votre compte sur notre site. Cela permet à plusieurs collaborateurs d'accéder aux informations du compte sur powr-connect.shop, en utilisant leurs identifiants uniques. Pour créer un accès pour un nouveau collaborateur, il vous suffit d'en faire la demande par mail [ici](https://powr-connect.shop/nous-contacter).`,
      },
      {
        question: "J'ai oublié mon identifiant ou mon mot de passe, comment faire ?",
        answer: `Cliquez [ici](https://powr-connect.shop/connexion?forgotPassword=1) pour réinitialiser votre mot de passe.
Pour réinitialiser votre mot de passe, veuillez suivre ces étapes : Cliquez sur l'option "mot de passe oublié", puis saisissez l'adresse e-mail associée à votre compte dans le champ prévu. Cochez la case "je ne suis pas un robot" et cliquez sur "confirmer". Un lien de réinitialisation de mot de passe vous sera envoyé à votre adresse e-mail.
Si vous avez oublié votre identifiant : rapprochez-vous de votre gestionnaire de compte chez POwR Connect.`,
      },
      {
        question: "J'ai créé un compte, pourquoi ne puis-je pas me connecter aussitôt ?",
        answer: `Lorsque vous demandez la création de votre compte sur notre site, la demande est traitée par nos services dans les meilleurs délais. Cela peut toutefois requérir un certain délai (temps, synchronisation des données). Une fois votre demande validée, vos recevrez un mail avec vos identifiants.`,
      },
      {
        question: "Comment modifier mes coordonnées ?",
        answer: `Vous avez la possibilité de modifier votre nom, prénom, fonction et numéro de téléphone via l'onglet mon profil sur votre compte dans vos informations personnelles.
Il n'est pas possible de modifier votre adresse électronique qui est par ailleurs votre identifiant de connexion. Pour ce type de demande, contactez nous [ici](https://powr-connect.shop/nous-contacter).`,
      },
    ],
  },
  {
    categoryLabel: "Prix / Panier",
    categorySlug: "prix",
    questions: [
      {
        question: "Est-ce que les prix sont HT ou TTC ?",
        answer: `Les prix exprimés sont HT.`,
      },
      {
        question: "A quoi correspond la DEEE dans mon panier ?",
        answer: `La DEEE ajoutée dans le panier correspond à Déchets d'équipements électriques et électroniques.
Également appelée éco-participation, il s'agit d'un « montant » ajouté au prix de vente des équipements électroniques et électriques, vendus en France. Ce montant a pour objectif de compenser les coûts de collecte, de gestion et de recyclage de ces équipements lorsqu'ils sont arrivés en fin de vie.`,
      },
      {
        question: "A quoi correspond la MFS dans mon panier ?",
        answer: `De l'acronyme « Maritime Fuel or Freight Surcharge » est un coût appliqué aux tarifs de transport maritime dans le but de compenser les fluctuations des coûts de carburant et de fret.`,
      },
      {
        question: "Comment j'ajoute un code promo à mon panier ?",
        answer: `Pour utiliser un code promo dans votre panier :
1. Saisir votre code promo dans l'espace dédié (sous le montant TTC, à droite de la fenêtre).
2. Appuyer sur le bouton « Ajouter » pour que la réduction soit prise en compte. L'intitulé de la promotion sera repris
3. Votre code promo sera repris sur votre confirmation de commande
`,
      },
    ],
  },
  {
    categoryLabel: "Livraison",
    categorySlug: "livraison",
    questions: [
      {
        question: "Comment je modifie mon adresse de livraison/facturation ?",
        answer: `Sur la page Mon compte / Mes adresses, vous pouvez consulter les adresses enregistrées pour votre compte. Il n'est pas possible de les modifier sur cette page. Pour toute modification concernant vos adresses, veuillez nous contacter par e-mail [ici](https://powr-connect.shop/nous-contacter).
Vous pouvez en revanche ajouter des adresses sur cette page via le formulaire Ajout d'une adresse.
Par ailleurs, dans le panier, à l'étape 2, il est possible d'ajouter de nouvelles adresses au moment de la commande.`,
      },
      {
        question: "Quels sont les délais de livraison ?",
        answer: `Un délai indicatif est précisé dans le panier de commande.
Toutefois, les délais de livraison sont déterminés en fonction des produits sélectionnés et de leur disponibilité en stock. Aussi, le délai pourra être révisé et il sera notifié lors de la confirmation de votre commande.`,
      },
      {
        question: "Quels sont les moyens de livraison ?",
        answer: `Vous avez le choix entre une livraison par affrètement ou par service de messagerie. Si nécessaire, il est également possible d'organiser une livraison par enlèvement sur demande auprès de votre interlocuteur chez POwR Connect.`,
      },
      {
        question: "Comment sont calculés les frais de livraison ?",
        answer: `Les frais de livraison sur le site sont calculés en fonction du lieu de livraison, pour la France métropolitaine uniquement. Pour les pays étrangers et les Dom-Tom, le montant des frais logistiques sera précisé par les équipes commerciales. Le calcul de ces frais diffère selon le mode de livraison choisi : l'affrètement ou la messagerie.

- Pour une livraison par affrètement :
Les frais logistiques liés à une livraison par affrètement sont calculés en fonction du montant total HT du panier de la commande et du département de livraison. Certains articles, de grande dimension notamment, exigent la livraison en affrètement : la livraison par messagerie sera alors impossible sur le site.

- Pour une livraison par messagerie :
Le montant des frais logistiques par messagerie est calculé en fonction du poids total de la commande et du département de livraison. La livraison par messagerie est généralement plus rapide qu'en affrètement.`,
      },
      {
        question: "Comment changer mon mode de livraison ?",
        answer: `Dans le panier, à l'étape 2, vous pouvez sélectionner le mode de livraison Affrètement ou Messagerie (sauf en cas de commandes de Modules et de rails de grande dimension, pour lesquels l'affrètement est requis).
Si vous souhaitez changer de mode de livraison pour une commande déjà passée et confirmée, contactez dès que possible nos services au 02 28 44 31 21.`,
      },
    ],
  },
  {
    categoryLabel: "Commande",
    categorySlug: "commande",
    questions: [
      {
        question: "Comment je sais que ma commande est validée ?",
        answer: `Après avoir validé votre commande sur le site, vous recevrez un e-mail accusant réception de votre commande. Votre affaire une fois passée en commande disparaît de la liste de vos Affaires et s'affiche dans la page Mes commandes / Commandes en attente de validation.
L'équipe commerciale examinera ensuite votre commande et vous recevrez un e-mail de confirmation dès qu'elle sera approuvée. La commande s'affichera alors sur la page Mes commandes / Commandes validées.`,
      },
      {
        question: "Quel est le process une fois ma commande validée sur le site ?",
        answer: `Lorsque vous effectuez une commande, notre équipe vous enverra un e-mail comprenant l'Accusé de Réception de Commande (ARC). Une fois l'expédition effectuée, vous recevrez un e-mail de suivi pour les envois par messagerie. Pour les commandes avec livraison par affrètement, le transporteur vous contactera directement afin de convenir d'un rendez-vous pour la livraison.`,
      },
      {
        question: "Comment modifier ou annuler ma commande ?",
        answer: `En cas de réception d'un mail de confirmation ou de réception de commande dont vous n'êtes pas à l'origine, veuillez-vous rapprocher de nos services au 02 28 44 31 21.
Si vous souhaitez modifier une commande déjà validée, vous devez en informer le plus rapidement possible nos services au 02 28 44 31 21.`,
      },
      {
        question: "Où puis-je retrouver l'historique de mes commandes ?",
        answer: `Les détails de vos commandes sont accessibles dans la page Mon Compte / Mes commandes. Pour y accéder, veuillez cliquer d'abord sur "mon compte" et ensuite sur "mes commandes". Dans cette section, vous retrouverez la liste complète de vos commandes passées, et vous pouvez également marquer certaines commandes en tant que favorites. Si vous le souhaitez, vous pouvez choisir de visualiser uniquement vos commandes favorites en activant l'option "afficher seulement les commandes favorites".`,
      },
      {
        question: "Comment je fais pour transformer mon affaire en commande ?",
        answer: `L'ensemble de vos affaires se trouvent dans l'onglet « mes affaires et devis » de votre compte. Dans la liste de vos affaires, vous avez la possibilité de « choisir cette affaire » ainsi celle-ci s'ajoutera directement à votre panier.`,
      },
      {
        question: "Comment je retrouve une facture ?",
        answer: `Pour accéder à votre facture, accédez à l'onglet "mes commandes" et choisissez l'option "demande de document" pour la commande concernée. À partir de là, vous pouvez sélectionner le document que vous souhaitez obtenir. Une fois choisi, le document vous sera envoyé par e-mail.`,
      },
      {
        question: "Comment je retrouve le détail d'une commande ?",
        answer: `Pour accéder à votre détail de commande, accédez à l'onglet "mes commandes" et choisissez l'option "demande de document" pour la commande concernée. À partir de là, vous pouvez sélectionner le document que vous souhaitez obtenir. Une fois choisi, le document vous sera envoyé par e-mail.`,
      },
      {
        question: "Comment je retrouve un bon de livraison ?",
        answer: `Pour accéder à votre bon de livraison, accédez à l'onglet "mes commandes" et choisissez l'option "demande de document" pour la commande concernée. À partir de là, vous pouvez sélectionner le document que vous souhaitez obtenir. Une fois choisi, le document vous sera envoyé par e-mail.`,
      },
      {
        question: "Je n'ai pas reçu de mails à propos de ma commande",
        answer: `Dans le cas où vous n'avez pas reçu de mail lié à votre commande passée sur notre site powr-connect.shop, je vous invite à contacter nos services au 02 28 44 31 21.`,
      },
    ],
  },
  {
    categoryLabel: "Produits",
    categorySlug: "produits",
    questions: [
      {
        question: "Comment je cherche un produit sur le site ?",
        answer: `Vous pouvez utiliser la barre de recherche présente au-dessus du menu. Il vous suffit de taper la marque, la référence ou le titre d'un produit, les résultats de votre recherche s'affichent en menu déroulant. Vous pouvez ensuite cliquer sur la référence souhaitée ou afficher tous les produits correspondants à votre recherche.`,
      },
      {
        question: "Je veux comparer des produits, comment je procède ?",
        answer: `Pour comparer des produits, cliquez sur le bouton « comparer » qui est épinglé sur la droite de chaque page. Vous pouvez ensuite ajouter des produits ou des gammes systèmes de fixation en cliquant sur les vignettes correspondantes.

Vous pouvez aussi sur chaque fiche produit, sélectionner « comparer ce produit », le produit sera alors directement ajouté au comparateur. Vous pouvez comparer jusqu'à 4 produits simultanément.
Attention : pour comparer des produits, ceux-ci doivent être issus de la même catégorie.`,
      },
      {
        question: "Comment j'ajoute des produits en favori ?",
        answer: `Sur chaque fiche produit se trouve une étoile. Il vous suffit de cliquer sur celle-ci pour ajouter le produit en favori. L'étoile deviendra jaune lorsque le produit est ajouté en favori.
Pour retirer un produit de vos favoris, il vous suffit de recliquer sur l'étoile qui redeviendra blanche.

L'ensemble de vos favoris se trouve dans l'onglet « mon compte », menu « mes favoris ». Depuis cette page, vous pouvez également supprimer des articles de vos favoris en cliquant sur l'icône poubelle.`,
      },
      {
        question: "Comment je vérifie le stock des produits ?",
        answer: `Le stock de chaque produit est visible dans la fiche produit, une fois connecté à votre compte. Il y a trois statuts de stock :
- En stock, indiquant le nombre de produits disponibles. Vous pouvez suivre les stocks des prochaines semaines sur les fiches de chaque produit en cliquant sur « voir les dispos ».
- En réassort, précisant la prochaine semaine de disponibilité
- Sur commande `,
      },
      {
        question: "Un article est sur commande, que faire ?",
        answer: `Si un article est notifié comme étant « sur commande », cela veut dire qu'il n'est pas disponible en stock et que nous allons le commander auprès de nos fournisseurs pour vous le livrer le plus rapidement possible. Pour ces produits, nous vous communiquons une date de livraison « estimée » indicative : notre équipe commerciale reviendra alors vers vous pour vous fournir plus de précisions sur le délai. Par ailleurs, nous ne pouvons garantir le prix au moment de la commande sur notre site, le tarif vous sera confirmé dans notre confirmation de commande.`,
      },
      {
        question: "Comment obtenir les documents techniques relatifs à mon produit ?",
        answer: `Les documents techniques sont disponibles sur la fiche produit dans l'encart « une question sur le produit ». Vous pouvez ainsi télécharger les documents en cliquant sur le bouton correspondant.`,
      },
      {
        question: "Comment créer plusieurs paniers de produits ?",
        answer: `Pour créer plusieurs paniers et les laisser en attente, vous devez créer des affaires.
Pour créer une affaire, connectez-vous. Dès que vous ajoutez des produits à votre panier, une affaire est créée : cliquez sur l'icône Panier pour consulter l'affaire en cours. Toute affaire créée est enregistrée automatiquement et vous pouvez également l'enregistrer sous un nom spécifique. Tant que l'affaire n'est pas validée en commande, elle est alors stockée dans la page Mon compte / Mes affaires et devis. Vous pourrez à tout moment la consulter.
Pour créer une nouvelle affaire, cliquez sur la page d'accueil et dans le bloc Les affaires, cliquez sur "Créer une affaire". Ou allez dans Mon compte / Mes affaires et devis et cliquez sur "Créer une affaire". Ajoutez les produits à l'affaire en cours.`,
      },
    ],
  },
  {
    categoryLabel: "Paiement",
    categorySlug: "paiement",
    questions: [
      {
        question: "Comment se passe le paiement de ma commande ?",
        answer: `Le paiement ne s'effectue pas directement sur notre site.
Les conditions de paiement sont définies lors de l'ouverture de votre compte client. La facture se déclenche quand la commande a été livrée, les délais de paiement commencent à la date de la facture.
L'acceptation de votre commande est soumise à la limite de l'encours garanti.`,
      },
      {
        question: "Quels sont les moyens de paiement disponibles ?",
        answer: `Sur notre site powr-connect.shop, il n'est pas encore possible de payer en ligne.
Vous pouvez payer par virement ou par LCR automatique.`,
      },
      {
        question: "Quels sont les délais de paiement ?",
        answer: `Les délais de paiement sont définis à l'ouverture de votre compte client.`,
      },
    ],
  },
  {
    categoryLabel: "SAV",
    categorySlug: "sav",
    questions: [
      {
        question: "Vous avez une autre question ?",
        answer: `Vous pouvez poser toutes vos questions sur notre formulaire de contact [ici](https://powr-connect.shop/nous-contacter). L'équipe de POwR Connect vous répondra dans les plus brefs délais.`,
      },
      {
        question: "J'ai un souci sur ma commande, qui contacter ?",
        answer: `Pour toutes questions techniques relatives à vos commandes, vous pouvez contacter nos équipes ADV qui sauront répondre à vos demandes. Vous pouvez les joindre du lundi au vendredi de 8h30 à 12h30 et de 14h à 18h au 02 28 44 31 21.`,
      },
      {
        question: "J'ai besoin d'un conseil sur un produit, qui peut me renseigner ?",
        answer: `Pour toutes questions techniques relatives à des produits, vous pouvez contacter votre gestionnaire de compte qui saura vous conseiller dans le choix de vos produits.`,
      },
    ],
  },
];
